import React, { useState, useEffect } from 'react';
import './SuperAdminCatalogManagement.css';
import CategoriesTab from './CategoriesTab';
import CatalogViewTab from './CatalogViewTab';
import FeaturedTab from './FeaturedTab';
import useCatalogManagementStore from '@/stores/AdminStore/CatalogManagementStore';

const CatalogManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'categories' | 'catalog' | 'featured'>('categories');

  const {
    categories,
    catalogCourses,
    featuredCourses,
    recommendationRules,
    fetchCategories,
    fetchCatalogCourses,
    fetchFeaturedCourses,
    fetchRecommendationRules,
  } = useCatalogManagementStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'categories' && !categories) {
      fetchCategories();
    }
  }, [activeTab, categories, fetchCategories]);

  useEffect(() => {
    if (activeTab === 'catalog' && !catalogCourses) {
      fetchCatalogCourses();
    }
  }, [activeTab, catalogCourses, fetchCatalogCourses]);

  useEffect(() => {
    if (activeTab === 'featured' && !featuredCourses) {
      fetchFeaturedCourses();
    }
    if (activeTab === 'featured' && !recommendationRules) {
      fetchRecommendationRules();
    }
  }, [activeTab, featuredCourses, recommendationRules, fetchFeaturedCourses, fetchRecommendationRules]);

  return (
    <div className="s-admin-catalog-management">
      <div className="s-admin-catalog-breadcrumb">
        <span className="s-admin-catalog-breadcrumb-item">Content Management</span>
        <span className="s-admin-catalog-breadcrumb-separator">&gt;</span>
        <span className="s-admin-catalog-breadcrumb-item s-admin-catalog-current">Catalog / Category</span>
      </div>

      <header className="s-admin-catalog-page-header">
        <div className="s-admin-catalog-header-content">
          <h1 className="s-admin-catalog-page-title">Catalog / Category Management</h1>
          <p className="s-admin-catalog-page-subtitle">Manage learning taxonomy and course discoverability</p>
        </div>
      </header>

      <nav className="s-admin-catalog-tabs">
        <button
          className={`s-admin-catalog-tab ${activeTab === 'categories' ? 's-admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Categories
        </button>
        <button
          className={`s-admin-catalog-tab ${activeTab === 'catalog' ? 's-admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('catalog')}
        >
          Catalog View
        </button>
        <button
          className={`s-admin-catalog-tab ${activeTab === 'featured' ? 's-admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('featured')}
        >
          Featured & Recommended
        </button>
      </nav>

      <div className="s-admin-catalog-content-section">
        {activeTab === 'categories' && <CategoriesTab />}
        {activeTab === 'catalog' && <CatalogViewTab />}
        {activeTab === 'featured' && <FeaturedTab />}
      </div>
    </div>
  );
};

export default CatalogManagement;
